import {css} from '@emotion/react';
import {Link} from '@travel-frontend/ui-components';

const cssTweaks = css`
  padding: 0;
  border: 0;
  background: none;
  font-weight: bold;
  text-align: left;
  cursor: pointer;
`;

type Props = React.PropsWithChildren<{
  onClick?: () => void;
}>;

export const ActionLink: React.FunctionComponent<Props> = ({
  children,
  onClick,
}) => {
  return (
    <Link as="button" css={cssTweaks} onClick={onClick}>
      {children}
    </Link>
  );
};
